import TopUsersChart from './TopUsersChart';

export default TopUsersChart;
